require("@rails/ujs").start();
require("lib/turbo");

require("controllers/application");

require("../stylesheets/tailwind.scss");
require("../stylesheets/site.scss");
